(() => {
  const initialize = root => {
    if (root.dataset.scentReady) return;
    const form = root.querySelector('[data-scent-controls]');
    const cards = [...root.querySelectorAll('[data-scent-card]')];
    const status = root.querySelector('[data-scent-results]');
    const empty = root.querySelector('[data-scent-empty]');
    if (!form || !status || !empty) return;
    root.dataset.scentReady = 'true';
    const moodInputs = [...form.querySelectorAll('input[name="mood"]')];
    const family = form.querySelector('[name="family"]');
    const search = form.querySelector('[name="q"]');
    const normalize = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    const indexedCards = cards.map(card => ({ card, text: normalize(card.dataset.scentSearch || ''), moods: card.dataset.moods.split(' '), families: card.dataset.families.split(' ') }));
    const restore = () => {
      const parameters = new URL(location.href).searchParams;
      const mood = parameters.get('mood') || 'all';
      (moodInputs.find(input => input.value === mood) || moodInputs[0]).checked = true;
      const selectedFamily = parameters.get('family') || 'all';
      family.value = [...family.options].some(option => option.value === selectedFamily) ? selectedFamily : 'all';
      search.value = (parameters.get('q') || '').slice(0, 80);
    };
    const apply = updateUrl => {
      const mood = moodInputs.find(input => input.checked)?.value || 'all';
      const words = normalize(search.value).split(/\s+/).filter(Boolean);
      let count = 0;
      for (const item of indexedCards) {
        const visible = (mood === 'all' || item.moods.includes(mood)) && (family.value === 'all' || item.families.includes(family.value)) && words.every(word => item.text.includes(word));
        item.card.hidden = !visible;
        if (visible) count += 1;
      }
      status.textContent = root.dataset.resultLabel.replace('__COUNT__', String(count));
      empty.hidden = count !== 0;
      if (updateUrl) {
        const url = new URL(location.href);
        for (const [key, value] of [['mood', mood], ['family', family.value], ['q', search.value.trim()]]) {
          if (!value || value === 'all') url.searchParams.delete(key);
          else url.searchParams.set(key, value);
        }
        history.replaceState(null, '', url.pathname + url.search + url.hash);
      }
    };
    form.addEventListener('submit', event => event.preventDefault());
    form.addEventListener('change', () => apply(true));
    search.addEventListener('input', () => apply(true));
    for (const button of root.querySelectorAll('[data-scent-reset]')) {
      button.addEventListener('click', () => {
        form.reset();
        apply(true);
      });
    }
    window.addEventListener('popstate', () => { restore(); apply(false); });
    restore();
    apply(false);
    form.hidden = false;
  };
  const initializeWithin = scope => {
    if (scope.matches?.('[data-scent-guide]')) initialize(scope);
    for (const root of scope.querySelectorAll('[data-scent-guide]')) initialize(root);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeWithin(document));
  else initializeWithin(document);
  document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
})();
